import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function InsightsPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/insights`)
      .then(res => res.json())
      .then(data => { setArticles(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white pt-20 md:pt-36 pb-16 md:pb-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-light tracking-tight text-black mb-8 md:mb-16 text-center">
          insights
        </h1>

        {loading ? (
          <p className="text-center text-gray-500">loading...</p>
        ) : articles.length === 0 ? (
          <p className="text-center text-gray-500">no articles yet.</p>
        ) : (
          <div className="grid md:grid-cols-2 gap-4 md:gap-8">
            {articles.map((article) => (
              <Link
                key={article.slug}
                to={`/insights/${article.slug}`}
                className="group block bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg p-5 md:p-8 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                data-testid={`insight-card-${article.slug}`}
              >
                <p className="text-sm text-gray-500 mb-3">{article.date}</p>
                <h2 className="text-xl md:text-2xl font-light tracking-tight text-black mb-3 group-hover:text-black/70 transition-colors">
                  {article.title}
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">{article.excerpt}</p>
                <span className="inline-block bg-black text-white px-4 py-1.5 rounded-full text-sm font-bold">
                  read more
                </span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
